module.exports = __webpack_public_path__ + "img/gantong.3049fc32.jpg";